import { render, staticRenderFns } from "./manage-integration-service-layout.vue?vue&type=template&id=2d57aa9c&scoped=true"
import script from "./manage-integration-service-layout.vue?vue&type=script&lang=js"
export * from "./manage-integration-service-layout.vue?vue&type=script&lang=js"
import style0 from "./manage-integration-service-layout.vue?vue&type=style&index=0&id=2d57aa9c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d57aa9c",
  null
  
)

export default component.exports